import { SurveyEditor } from '/src/features/addons/surveys/editor/SurveyEditor';

// eslint-disable-next-line no-restricted-syntax
export default function NewSurveyTemplate() {
  return <SurveyEditor isTemplate={true} />;
}
